import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IApiDependencySegment, catchApiError } from '@cbridge-packages/api-admin';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { UserTranslator } from '@cbridge-packages/user';
import { UserListAction } from '../userList.action';

type IDependencies = IApiDependencySegment;

export const loadUserListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(UserListAction.load),
  mergeMap((payload) => {
    return dependencies.api.getUserList(payload).pipe(
      mergeMap((response) => {
        const list = (response.users ?? []).map(UserTranslator.fromApi);

        return [
          UserListAction.loadDone({ list }),
        ];
      }),
      catchApiError((error) => {
        return [
          UserListAction.loadFailed(),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
